module.exports = __webpack_public_path__ + "assets/img/KRUG_BRASIL__0407-min.9d0bd3b1.jpg";